var exports = {
  "vR": "tabs__wS8u7B",
  "m0": "panelTop__cQymbh",
  "eC": "panelScrollable__m9G9sf",
  "F1": "bodyLayout__Pv3tD_",
  "o1": "actions__SbRmfo",
  "uH": "actionsRight__dKorwX",
  "Nw": "commentsHeadingRow__lEhhq-",
  "LE": "commentsHeading__mPY_NV",
};

module.exports = exports;
